<div #addTenantButton class="offcanvas offcanvas-end customeoff {{ tenantadd_edit ? 'show':''}}" tabindex="-1" id="tenantadd_edit" data-bs-backdrop="static">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">Personal Information</h5>
      <button type="button" class="btn-close" aria-label="Close"  (click)="propertyClose()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" >
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()" autocomplete="off"> 
        <div class="row">
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-1" class="form-label">First Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="user" formControlName="first_name">
              <div *ngIf="userForm?.get('first_name')?.invalid && userForm?.get('first_name')?.touched" class="required">
                First Name is required
            </div>
          </div>	
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-2" class="form-label">Last Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="exampleFormControlInput1-2" placeholder="user1" formControlName="last_name">
              <div *ngIf="userForm?.get('last_name')?.invalid && userForm?.get('last_name')?.touched" class="required">
                Last Name is required
            </div>
          </div>	
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-3" class="form-label">Email<span class="text-danger">*</span></label>
              <input type="email" class="form-control" id="exampleFormControlInput1-3" placeholder="abc@mail.com" formControlName="email">
              <div *ngIf="userForm?.get('email')?.invalid && userForm?.get('email')?.touched" class="required">
                Provide valid email 
            </div>
          </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-4" class="form-label">Mobile Number<span class="text-danger">*</span></label>
              <ngx-intl-tel-input
              formControlName="phone" [cssClass]="'default-select style-1 form-control'"   [preferredCountries]="['in','us', 'gb', 'ca']" [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"	[selectFirstCountry]="false" [maxLength]="15" [phoneValidation]="true" [separateDialCode]="true" autcomplete="off"></ngx-intl-tel-input>
            <div *ngIf="userForm?.get('phone')?.errors && userForm?.get('phone')?.touched" class="required">
                Provide valid mobile number
            </div>                                            
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Alternate Email</label>
            <input type="email" class="form-control" id="exampleFormControlInput1-3" placeholder="aa@aa.com" formControlName="alternate_email">                                            
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-4" class="form-label">Alternate Mobile Number</label>
            <ngx-intl-tel-input
            formControlName="alternate_phone" [cssClass]="'default-select style-1 form-control'"   [preferredCountries]="['in','us', 'gb', 'ca']" [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"	[selectFirstCountry]="false" [maxLength]="15" [phoneValidation]="false" [separateDialCode]="true" autcomplete="off"></ngx-intl-tel-input>    
        </div>
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Gender</label>
        <div>
            <mat-radio-group aria-label="Select gender" formControlName="gender">
                <mat-radio-button value="male">Male</mat-radio-button>
                <mat-radio-button value="female">Female</mat-radio-button>
                <mat-radio-button value="others">Others</mat-radio-button>
            </mat-radio-group> 
        </div>                                           
        </div>  
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Date of birth</label>
        <div>
            <mat-form-field>
                <mat-label>Select dob</mat-label>
                <input matInput [matDatepicker]="dp3" [matDatepickerFilter]="disableFutureDates" formControlName="dob">
                <mat-datepicker-toggle matIconSuffix [for]="dp3" ></mat-datepicker-toggle>
                <mat-datepicker #dp3 disabled="false"></mat-datepicker>
            </mat-form-field>  
        </div>                                          
        </div> 
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Driving License No</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="D123456" formControlName="driving_license">                                            
          </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Marital Status</label>
            <select class="form-select" formControlName="marital_status">
                <option  data-display="Select" value="" selected>Please select</option>
                <option value="single">Single</option>                          
                <option value="married">Married</option>
                <option value="widow">Widow</option>
                <option value="widower">Widower</option>
            </select>                                            
          </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Aadhaar Number</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="1234 5678 0987" formControlName="aadhar">                                            
          </div> 

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Pan Number</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="A123D56" formControlName="pan">                                            
          </div> 

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Allow Login</label>
        <div>
            <mat-radio-group aria-label="Allow Login" formControlName="allow_login">
                <mat-radio-button value="true">Yes</mat-radio-button>
                <mat-radio-button value="false">No</mat-radio-button>
            </mat-radio-group> 
        </div>                                           
        </div>

      </div>
              <div>
                  <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="userForm.invalid || loadingService.isLoading()">Submit</button>
                  <button class="btn btn-danger lightme-1" type="button" (click)="propertyClose()">Cancel</button>
              </div>
      </form>
        </div>
    </div>
  </div>		
  @if(tenantadd_edit){
    <div class="offcanvas-backdrop fade show" (click)="toggleSearch()"></div>
  }